import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'

import Icon from '../../shared/components/Icon'
import DateFormatter from '../../shared/components/DateFormatter'

export default class ListItem extends Component {

  static propTypes = {
    item: PropTypes.object,
  }

  render() {
    const { item } = this.props
    const { type } = item

    // museum
    let icon = 'house'
    let name = item.name
    let subtitle = ''
    const temporarilyNotBookable = item.temporarilyNotBookable

    if (type !== 'museum') {
      icon = type === 'program' ? 'program' : 'guided-tour'
      name = item.title
      subtitle = ` (${item.museumName})`
    }

    const linkTo = `/release/${type}/${item.id}/versions`

    return (
      <li className="release iconized">
        <div>
          <Icon
            className="nav-list-icon"
            size={18}
            name={`${icon}-grey`}
          />

          <Link to={linkTo}>
            {`${name}${subtitle}`}
            {' '}
            {temporarilyNotBookable ? (
              <Icon
                className="inline"
                name="virus-turquoise"
              />
            ) : ''}
            <br />
            <small>
              zuletzt aktualisiert&nbsp;
              <DateFormatter date={item.updatedAt} />
            </small>
          </Link>

          <span className="tools">
            <Link
              to={linkTo}
              title="Freigabe bearbeiten"
            >
              <Icon
                className="tool-icon"
                size={18}
                name="pencil-turquoise"
              />
            </Link>
          </span>

        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/release/components/ListItem.js